import React, { useState } from 'react';
import './App.css';

function App() {
  const [orderName, setOrderName] = useState('');
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showContact, setShowContact] = useState(false);

  const fetchTrackingInfo = async () => {
    if (!orderName.trim()) {
      setMessage('Please enter an order ID');
      return;
    }
    
    setLoading(true);
    setMessage('');
    setTrackingInfo(null);
    
    try {
      const response = await fetch(`https://ordertrackerbackend.onrender.com/api/tracking/${encodeURIComponent(orderName)}`);
      const data = await response.json();
      
      if (data.error) {
        setMessage(data.error);
        setTrackingInfo(null);
      } else if (data.message) {
        setMessage(data.message);
        setTrackingInfo(null);
      } else {
        setTrackingInfo(data);
        setMessage('');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setMessage('Error fetching tracking information. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      fetchTrackingInfo();
    }
  };

  return (
    <>
      <div className="navbar">
       <div className="logo-container">
        <a href="https://onlyscrews.in" rel="noopener noreferrer">
       <div className="app-title">
        <img src="../os_logo.png" alt="Onlyscrews Logo" className="logo" />
      </div>
  </a>
</div>
        <button className="contact-btn" onClick={() => setShowContact(!showContact)}>
          {!showContact ? "Contact Us" : "Track Order"}
        </button>
      </div>

      <div className="main-container">
        {!showContact ? (
          <>
            <div className="logo-banner">
              <div className="app-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
                Order Tracker
              </div>
              <p className="instructions">
                Enter your Order's Order ID to get the latest updates on your shipment.<br/>
                <strong>Note:</strong> Order ID is the number you received in your order confirmation email/checkout page.<br/>
                <strong>Example:</strong> #ONLSCRXXXX
              </p>
              
            </div>

            <div className="card">
              <div className="card-body">
                <div className="search-form">
                  <div className="input-container">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Enter your Order ID"
                      value={orderName}
                      onChange={(e) => setOrderName(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                    <button className="search-button" onClick={fetchTrackingInfo}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                      Track Order
                    </button>
                  </div>
                </div>

                {loading && (
                  <div className="loader">
                    <div className="loader-spinner"></div>
                    <div className="loader-text">Fetching order details. (It may take Upto 5 Mins sometimes for server to spin up)</div>
                  </div>
                )}

                {message && (
                  <div className="message-container">
                    <div className="message error">{message}</div>
                    <button className="contact-support-btn" onClick={() => setShowContact(true)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      Contact Support
                    </button>
                  </div>
                )}
              </div>
            </div>

            {trackingInfo && (
              <div className="tracking-info">
                <div className="tracking-info-header">
                  <h3>Order Details</h3>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <div className="tracking-info-body">
                  <div className="tracking-detail">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span className="tracking-label">Order ID:</span>
                    <span className="tracking-value">{orderName}</span>
                  </div>
                  <div className="tracking-detail">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span className="tracking-label">Status:</span>
                    <span className="tracking-value highlight">
                      {trackingInfo.displayStatus && trackingInfo.displayStatus.toUpperCase() === 'FULFILLED' 
                        ? 'Dispatched' 
                        : (trackingInfo.displayStatus || 'Processing')}
                    </span>
                  </div>
                  <div className="tracking-detail">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="1" y="3" width="15" height="13"></rect>
                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                      <circle cx="5.5" cy="18.5" r="2.5"></circle>
                      <circle cx="18.5" cy="18.5" r="2.5"></circle>
                    </svg>
                    <span className="tracking-label">Carrier:</span>
                    <span className="tracking-value">{trackingInfo.carrier}</span>
                  </div>
                  <div className="tracking-detail">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 18l6-6-6-6"></path>
                    </svg>
                    <span className="tracking-label">Tracking #:</span>
                    <span className="tracking-value">{trackingInfo.tracking_number}</span>
                  </div>
                  <a 
                    href={trackingInfo.tracking_url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="external-tracking-btn"
                  >
                    Track on {trackingInfo.carrier}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                  </a>
                </div>
              </div>
            )}
            <p className="instructions important-note">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                  <line x1="12" y1="9" x2="12" y2="13"></line>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                Please record an unboxing video before opening the package as a proof to claim any mismatch.
              </p>
          </>
        ) : (
          <div className="contact-card">
            <div className="contact-header">
              <h2>Contact Us</h2>
            </div>
            <div className="contact-body">
              <p className="contact-description">
                Have questions or need help with your order?<br />
                Reach out to us!
              </p>
              <div className="contact-item">
                <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <span className="contact-label">Email:</span>
                <a href="mailto:support@shoptrack.com" className="contact-value">
                  support@onlyscrews.com
                </a>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span className="contact-label">Phone:</span>
                <a href="tel:+918867622930" className="contact-value">
                  +91 93632 34443
                </a>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21"></path>
                  <path d="M9 10a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0v-2z"></path>
                  <path d="M14 10a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0v-2z"></path>
                  <path d="M9 15h6"></path>
                </svg>
                <span className="contact-label">WhatsApp:</span>
                <a href="https://wa.me/8867622930" target="_blank" rel="noopener noreferrer" className="contact-value">
                  +91 88676 22930
                </a>
              </div>
            </div>
            <div className="contact-footer">
              Our support team is available Monday - Sunday, 9 AM to 9 PM.
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default App;